import React, { useContext } from "react";
import { Album } from "../types";
import {
  CheckOutline,
  CheckFilled
} from "../../../BrowseEvent/components/vectors/CheckIcon";
import {
  CartOutline,
  CartFilled
} from "../../../BrowseEvent/components/vectors/AddToCartIcon";
import millisecondsTohms from "../../../../utils/millisecondsTohms";
import { OrgDownloadContext } from "../../../OrganizationPhotos/OrgDownloadContext";
const playIcon = require("../../styles/play.svg");

interface MediaThumbnailComponentProps {
  props: {
    item: {
      videoContent: any;
      videoDuration: string | number;
      thumbnail: string | undefined;
      id: number;
      album: Album;
      hidden: boolean;
      favorite: boolean;
      isSelected: boolean;
    };
    imageProps: JSX.IntrinsicAttributes &
      React.ClassAttributes<HTMLImageElement> &
      React.ImgHTMLAttributes<HTMLImageElement>;
  };
  handleImageSelect: ({ photo }: { photo: any }) => void;
  primaryColor: string;
  securedOrgView: boolean | undefined;
  disableSelectIcon?: boolean;
  directDownloadEnabled?: boolean;
}

const MediaThumbnailComponent = ({
  props,
  handleImageSelect,
  primaryColor,
  securedOrgView,
  disableSelectIcon,
  directDownloadEnabled
}: MediaThumbnailComponentProps) => {
  const [show, setShow] = React.useState(false);
  const orgDownloadContext = useContext(OrgDownloadContext);

  const ThumbnailSectionIcon = () => {
    if (orgDownloadContext?.fromSecuredFaceSearch) {
      if (!freePhoto && directDownloadEnabled) {
        return PaidMediaIcon;
      }
    }
    return (
      <div
        className="geo-cart-icon-container"
        onClick={e => {
          e.stopPropagation();
          handleImageSelect({ photo: props.item });
        }}
      >
        {securedOrgView && !disableSelectIcon && directDownloadEnabled ? (
          props.item.isSelected ? (
            <CheckFilled color={primaryColor} />
          ) : (
            <CheckOutline />
          )
        ) : props.item.isSelected ? (
          <CartFilled color={primaryColor} />
        ) : (
          <CartOutline />
        )}
      </div>
    );
  };

  const PaidMediaIcon = (
    <div className="geo-cart-icon-container paid-media-symbol-container">
      <span>$</span>
    </div>
  );

  const VideoThumbnail = () => {
    const orgDownloadContext = useContext(OrgDownloadContext);

    if (orgDownloadContext?.fromSecuredFaceSearch) {
      if (!freePhoto && directDownloadEnabled) {
        return PaidMediaIcon;
      }
    }

    return (
      <div style={{ textAlign: "center", cursor: "pointer" }}>
        <span className="time-stamp">
          {millisecondsTohms(props.item.videoDuration)}
        </span>
        <img className="play-icon" src={playIcon} />
        {ThumbnailSectionIcon()}
        <img
          height="120px"
          src={props.item.thumbnail}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          alt={`${props.item.album.name}-${props.item.id}`}
        />
      </div>
    );
  };

  const freePhoto = props.item.album.event.price === 0;

  if (props.item.videoContent) {
    return VideoThumbnail();
  } else
    return (
      <>
        {ThumbnailSectionIcon()}
        <img
          {...props.imageProps}
          alt={`${props.item.album.name}-${props.item.id}`}
        />
      </>
    );
};

export default MediaThumbnailComponent;
